__turbopack_context__.v({
  "fundraisercontainer": "_3iuura_fundraisercontainer",
  "fundraiserdata": "_3iuura_fundraiserdata",
  "fundraiserdescription": "_3iuura_fundraiserdescription",
  "mobiletitle": "_3iuura_mobiletitle",
});
